import { render, staticRenderFns } from "./PacienteFichaMedica.vue?vue&type=template&id=436c6908&scoped=true"
import script from "./PacienteFichaMedica.vue?vue&type=script&lang=js"
export * from "./PacienteFichaMedica.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaMedica.vue?vue&type=style&index=0&id=436c6908&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c6908",
  null
  
)

export default component.exports